import React from 'react'
import { Icon } from '../types'

export const SidebarSimBackground = (props: Icon) => (
  <svg className={props.className} viewBox="0 0 304 54">
    <path fill="#00939A" fillOpacity=".1" d="M0 54V30.8A401.2 401.2 0 01152 .5C204.4.5 255.3 11 304 30.8V54H0z" />
  </svg>
)
